import React from 'react'
import { Route as ORoute, Redirect, RouteProps } from 'react-router-dom'
import { isAuthenticated } from '../auth'
import { appRef } from '../app'

interface IRouteProps extends RouteProps {
    auth?: boolean
    guest?: boolean // For routes that should only be accessible when NOT logged in
    permission?: string
}

function hasPermission(required?: string): boolean {
    if (!required) return true
    const keys = appRef.state.user?.permissionKeys || []
    if (keys.includes(required)) return true
    return keys.some(item => required.startsWith(`${item}.`))
}

export const Route: React.FC<IRouteProps> = ({ component, auth, guest, permission, ...rest }) => {
    if (auth && !isAuthenticated()) {
        return <Redirect to="/login" />
    }
    if (guest && isAuthenticated()) {
        return <Redirect to="/" />
    }
    if (auth && !hasPermission(permission)) {
        return <Redirect to="/" />
    }
    return <ORoute {...rest} component={component} />
}
